import { Component, ElementRef, Input, OnInit, Renderer2 } from '@angular/core'
import { FormBuilder } from '@angular/forms'
import * as lodash from 'lodash'
import { FieldsEditorActionManagerService } from '../../fields-editor/fields-editor-action-manager.service'
import { FieldPlaceholderComponent } from '../field-placeholder.component'
import { untilDestroy } from '@tokeet-frontend/tv3-platform'
import { SignFieldType } from '@tokeet-frontend/signature'

@Component({
  selector: 'app-textbox-placeholder',
  templateUrl: './textbox-placeholder.component.html',
  styleUrls: ['./textbox-placeholder.component.scss', '../global-fields.scss'],
})
export class TextboxPlaceholderComponent extends FieldPlaceholderComponent implements OnInit {
  type = SignFieldType.Textbox

  defaultLabel = $localize`Textbox`

  @Input() required = true
  @Input() label: string

  get fieldValue() {
    return this.form.get('value').value
  }

  constructor(
    render: Renderer2,
    fb: FormBuilder,
    elementRef: ElementRef,
    actionManager: FieldsEditorActionManagerService
  ) {
    super(render, fb, elementRef, actionManager)
  }

  ngOnInit() {
    super.ngOnInit()

    this.form
      .get('label')
      .valueChanges.pipe(untilDestroy(this))
      .subscribe(() => {
        this.onLabelChanged(this.label)
      })
  }

  onLabelChanged(newValue) {
    if (!newValue) {
      return
    }
    lodash.set(this.data.attributes, 'field', `attributes.${lodash.snakeCase(newValue)}`)
  }
}
